import React, { useEffect, useCallback, useState } from 'react';

import {
    Select,
    CheckBox,
} from '../Form';
import { RatingChoices } from '../../utils/constants';

const RatingChoiceFields = (props) => {
    const {
        hasTennisResults,
        ratingChoiceOptions,
        showRatingChoiceSelect,
        formApi,
    } = props;

    const { values, setValue, reset } = formApi;

    const [disablePickleball, setDisablePickleball] = useState(values.ratingChoice === RatingChoices.PROGRESSION_BALL_RATING);

    useEffect(() => {
        if (values.ratingChoice === RatingChoices.PROGRESSION_BALL_RATING) {
            setValue('showPickleballRating', false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChangeRatingChoice = useCallback((value) => {
        if (value === RatingChoices.PROGRESSION_BALL_RATING) {
            setValue('showPickleballRating', false);
        } else {
            reset('showPickleballRating');
        }
    }, [setValue, reset, values]);

    useEffect(() => {
        const fieldsToCheck = ['showTennisRating', 'showPickleballRating'];

        const isAtLeastOneDisplayRatingEnabled = fieldsToCheck.reduce((acc, curVal) => {
            return values[curVal] || acc;
        }, false);

        if (!isAtLeastOneDisplayRatingEnabled) {
            setTimeout(() => {
                setValue('showTennisRating', true);
            }, 500);
        }
    }, [values, setValue]);

    useEffect(() => {
        setDisablePickleball(values.ratingChoice === RatingChoices.PROGRESSION_BALL_RATING);
    }, [values.ratingChoice === RatingChoices.PROGRESSION_BALL_RATING]);

    return (
        <div className="form-group from-group-xl">
            <label className="mb8" data-testid="profile-edit.ratings.label">
                Ratings display
            </label>
            <CheckBox
                id="showTennisRating"
                field="showTennisRating"
                customLabel={`Tennis`}
                formGroupCssClass="mb8"
                disabled={hasTennisResults}
                data-testid="profile-edit.ratings.tennis-checkbox"
            />
            {hasTennisResults && (
                <small>
                    Tennis ratings display cannot be deselected once results have been posted.
                </small>
            )}
            {showRatingChoiceSelect && (
                <Select
                    label="Select the rating you'd like to display"
                    id="ratingChoice"
                    field="ratingChoice"
                    options={ratingChoiceOptions}
                    attributeToSave="value"
                    formGroupCssClass="ml24 mb8"
                    onChange={onChangeRatingChoice}
                    data-testid="profile-edit.rating-choice-select"
                />
            )}
            {!disablePickleball && (
                <CheckBox
                    id="showPickleballRating"
                    field="showPickleballRating"
                    customLabel={`Pickleball`}
                    formGroupCssClass="mb8"
                    data-testid="profile-edit.ratings.pickleball-checkbox"
                />
            )}
        </div>
    );
};

export default RatingChoiceFields;
